
import { Link } from 'react-router-dom';
import { Settings } from 'lucide-react';
import { useSuperAdminAuth } from '@/contexts/SuperAdminAuthContext';

const AdminLink = () => {
  const { user } = useSuperAdminAuth();

  // Only show the admin link if user is authenticated as super admin
  if (!user) {
    return null;
  }

  return (
    <Link 
      to="/oil-request-admin" 
      className="hidden md:flex items-center text-autocare-blue hover:text-autocare-blue-light transition-colors"
    >
      <Settings className="h-4 w-4 ml-1" />
      إدارة الطلبات
    </Link>
  );
};

export default AdminLink;
